import Backbone from 'backbone'
import treeTopToolbar from './nav-top-toolbar.hbs'
import Gardener from 'scoreboard/components/gardener'
import $ from 'jquery'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import conductor from 'scoreboard/components/conductor'
import emptyTree from './empty-tree.hbs'
import globals from 'scoreboard/components/globals'
import NoObjectView from 'scoreboard/components/no-object'
import appDisplay from 'scoreboard/components/app-display'
import metadata from 'scoreboard/components/metadata'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import constants from 'scoreboard/components/constants'
import HttpStatusCodes from 'http-status-codes'
import guard from 'scoreboard/components/unsaved/guard'
import guardConstants from 'scoreboard/components/unsaved/guard-constants'
import sections from 'scoreboard/components/sections'
import requiresOrg from 'scoreboard/components/requires-org'
import SizeSpy from 'scoreboard/components/size-spy'
import config from 'scoreboard/components/config'
import navBottomToolbar from './nav-bottom-toolbar.hbs'
import notFound from 'scoreboard/components/not-found.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import { isV5 } from 'scoreboard/components/version'

var Nav = Backbone.View.extend({
	className: 'nav-pane-content',

	// indicates whether the "Add Folder" button is applicable to this tree type.
	// Can be overridden by subclass
	folders: true,

	addLabelCode: null,

	// the section code this nav tree applies to. Must be provided by subclass
	// ex. 'scorecards'
	section: null,

	// indicates that the URL should be modified when in edit mode.  This will
	// always be true except for orgs and briefings
	changeUrl: true,

	// true if the add button should be disabled when creating a new object
	disableAddOnNew: true,

	// If user clicked 'Edit' before the display is loaded this is set so that
	// the app-router can enter edit mode instead of the overview
	awaitingEdit: false,

	// most events are coming from nav-bottom-toolbar.js
	events: {
		'click .edit': 'clickEdit',
		'click .add-folder': 'addFolder'
	},

	Gardener: Gardener,

	_gardener: function(options = {}) {
		let finderBackground = isV5() ? 'dim' : 'light'

		// Pass all options through except for:
		// el: gardeners must always have their own elements (inside the nav pane)
		const passThroughOptions = _.omit(options, ['el'])
		const gardenerOptions = _.extend({
			section: this.section,
			finderOptions: {
				// The finder inherits the light/dark theming coming from the treeType
				type: _.result(this.options, 'treeType') || finderBackground
			}
		}, passThroughOptions)
		return new this.Gardener(gardenerOptions)
	},

	_interested: function(model) {
		return this.gardener && this.gardener.interested(model)
	},

	/**
	 * @param {Number} options.id
	 * @param {Number} options.orgId
	 * @param {String} [options.searchType='dim'] Finder search type
	 */
	initialize: function(options) {
		this.options = options || {}

		_.bindAll(this, 'onSelect', 'clickNode')
		this.on('resize', () => this.resize())

		// These must be bound before the gardener is created so the node still
		// exists in the tree when a node is removed, which allows us to navigate
		// to the newly selected node.
		this.listenTo(Backbone, 'delete:domain-object', this._deleteDomainObject)
		this.listenTo(Backbone, 'add:domain-object', this._addDomainObject)
		this.listenTo(Backbone, 'move:domain-object', this._moveDomainObject)

		// This initiates the XHR, we want to do that right away
		this.gardener = this._gardener(this.options)
		// must create the gardener before binding events
		this._bindEvents()

		// the tree is going to display when something is changed, so clear out
		// the finder
		this.listenTo(Backbone, 'add:domain-object edit:domain-object delete:domain-object',
			() => this.gardener.finder.clear())
	},

	render: function() {
		// must render after binding events so that the nav can respond to
		// events before the gardener
		this.gardener.render()
		this._ensureSelection()
		this.$el.addClass(this.section)

		let folders = _.isFunction(this.folders) ?
			this.folders(this.gardener.getOrgId()) : this.folders
		this.gardener.$('.finder').after(treeTopToolbar({
			folders,
			addLabelCode: metadata[this.section].addLabelCode,
			sectionIcon: metadata[this.section].sectionIcon,
			dark: _.result(this.options, 'treeType') == 'dark',
			light: _.result(this.options, 'treeType') == 'light'
		}))

		if (this.$el.children('.node').length == 0) {
			this.showLoadingDots()
		}

		// Only apply sizeSpy() to the nav-pane. The org-pane also uses this
		// component, so we don't want to apply the classes to that.
		this.isNavPane = this.$el.hasClass('nav-pane-content')
		if (this.isNavPane) {
			this.sizeSpy = new SizeSpy({
				el: this.$el,
				classes: [ 'nav-small', 'nav-large' ],
				breakpoints: [256]
			})
			this.sizeSpy.spy()
		}

		return this
	},

	showLoadingDots: function() {
		this.loadingTimeout = setTimeout(function() {
			this.$el.append(loadingDots())
			this.$('.gardener').addClass('is-not-displayed')
		}.bind(this), constants.LOADING_TIME)
	},

	clearLoadingDots: function() {
		// if the loading dots aren't displayed yet, prevent them from being
		// displayed
		clearTimeout(this.loadingTimeout)
		// remove any loading dots that may be visible
		this.$('.loading-dots').remove()
		this.$('.gardener').removeClass('is-not-displayed')
	},

	_bindEvents: function() {
		this.listenTo(this.gardener.finder, 'find', () => this.trigger('search'))
		this.listenTo(this.gardener, 'stream', stream => this.trigger('stream'))
		//#33354 #33273 #32756 #31937
		//this looks to be the culprit of the "double load", previously when
		//binding events, we would immediately bind the tree select event to the
		//onSelect method in nav, which calls the conductor and ultimately cause
		//a reload.  Instead of binding the select immediately, we defer the
		//bind until after the tree has rendered, so that any auto selection,
		//does not trigger a reloading of the display.  Conceptually this also
		//mirror the intent of listening to "user" tree selections, instead of
		//the "auto" selection made at the initial creation of the tree
		this.listenToOnce(this.gardener, 'tree:rendered', () => {
			this.listenTo(this.gardener, 'select', this.onSelect)
		})

		this.listenTo(this.gardener, 'change:tree', this._changeTree.bind(this))
		this.listenTo(this.gardener, 'success', () => {
			// whenever the server successfully locates a tree
			this.clearLoadingDots()
			this.trigger('success') // must be first
			this.toggleTree(true)
		})
		this.listenTo(this.gardener, 'error', stream => {
			// whenever the server fails to locate a tree
			this.trigger('error') // must be first
			this.gardenerError(stream)
		})
		this.listenTo(this.gardener, 'success error', () => {
			this.secure()
		})
	},

	// hide anything the user shouldn't see
	secure: function() {
		this.$el.toggleClass('is-editable', this.isEditable(this.gardener.getOrgId()))
		this.$('.nav-top-toolbar').toggleClass('is-not-displayed', !this.displayTreeTopToolbar(this.gardener.getOrgId()))
	},

	_toggleFolderButton: function(show) {
		this.$('.nav-top-toolbar')
			.toggleClass('two-buttons', show)
			.toggleClass('single-button', !show)
			.find('.add-folder')
				.toggleClass('is-not-displayed', !show)
	},

	// returns whether the nav pane should allow its contents to be edited
	isEditable: _.constant(false),

	// returns whether the tree top toolbar should be displayed based on permissions
	// in most cases this will be the same as isEditable
	displayTreeTopToolbar: function (orgId) {
		return this.isEditable(this.gardener.getOrgId())
	},

	/**
	 * Instructs the gardener to change its display based on the given options
	 */
	show: function (opt) {
		this.options = opt || {}
		if (!this.gardener) {
			this.render()
		}
		this.gardener.show(opt)

		this._onceTreeLoaded(() => {
			// need to wrap in process.nextTick or else the buttons won't be
			// there yet to toggle
			process.nextTick(() => {
				this._toggleNewDomainObjectButton()
				this._toggleNewFolderButtonIfNeeded()
				//the nav uses the org id to determine whether the user has permissions to edit
				//but in some cases (e.g. replication) this is not enough to determine whether
				//the nav should allow editing of objects
				this._toggleEditabilityIfNeeded()
			})
		})
		return this
	},

	_toggleNewDomainObjectButton() {
		var disableAdd = _.endsWith(Backbone.history.fragment, '/new')
		this.$('.new').prop('disabled', disableAdd && this.disableAddOnNew)
	},

	_toggleNewFolderButtonIfNeeded() {
		if (this.folders) {
			var disableAddFolder = _.endsWith(Backbone.history.fragment, '/new-folder')
			this.$('.add-folder').prop('disabled', disableAddFolder)
		}
	},

	_toggleEditabilityIfNeeded() {
		this._onceTreeLoaded(() => {
			if (Backbone.history.fragment.endsWith('/edit')) {
				//handles if the user manually navigated to a editable url (regardless if they had permissions)
				//toggling the editability gives the user a way out of edit mode.
				this.toggleEditability(true)
			} else {
				let selected = this.gardener.tree.selected()
				if (selected) {
					this.toggleEditability(this._isSelectedItemEditable(selected)
						&& this.isEditable(this.gardener.getOrgId()))
				}
			}
		})
	},

	_isSelectedItemEditable(selected) {
		//if we're viewing a node that's replicated, ensure the nav cannot be toggled to edit mode
		return selected && _.isNil(selected.syncId)
	},

	_changeTree: function() {
		this.gardener.finder.clear()
		if (this.gardener.options.orgId) {
			globals.orgId = this.gardener.options.orgId
		}
	},

	// ensures something in the tree is selected
	_ensureSelection: function() {
		if (!this.gardener.options.id && this.gardener.stream) {
			// https://github.com/SpiderStrategies/kalpa-tree/issues/258#issuecomment-170565306
			var rootId
			this.gardener.once('node', function(root) {
				rootId = root.id
			}.bind(this))
			this.gardener.stream.once('end', function(root) {
				this.gardener.tree.select(rootId, { animate: false, silent: true })
			}.bind(this))
		}
	},

	/**
	 * Handles a change to the selection in the tree.
	 * Subclasses can override this function
	 *
	 * Note: This is not fired for gardeners that show a 'Select' button, when that button is clicked.
	 * (The select button requires this.treeActions.on('selected', () => {...}))
	 *
	 * @param node the tree node that was selected.
	 */
	onSelect: function(node) {
		this.gardener.finder.clear()
		if (Backbone.history.fragment.indexOf('/new') != -1) {
			// If we're in "add a new object from the display pane" mode,
			// and a tree node was clicked, we can't use changeId because
			// we don't want /new anymore. So do it manually
			conductor.edit(this.section, node.id)
		} else if (_.startsWith(Backbone.history.fragment, sections.toUrl(this.section))) {
			conductor.changeId(node.id, { force: true })
			// When the tree is done transitioning (collapsing/expainding) from the
			// selection, change the .tree ul height slightly to make sure scrolling
			// behaves like it should. I'm not sure why exactly but this
			// triggers some kind of redraw for chrome so the nav doesn't ignore
			// nodes outside the scrollable container.
			// https://github.com/SpiderStrategies/Scoreboard/issues/41034
			this.$('.tree').on('transitionend', () => {
				let ul = this.$('.tree ul')[0]
				ul.style.height = '1px'
				ul.style.height = '0px'
			})
		} else {
			conductor.overview(this.section, node.id)
		}
	},

	gardenerError: function(stream) {
		// if we are on a URL like organizations/342/briefings, the 404
		// indicates no existing data there so we want a create button
		let url = 'organizations/[0-9]+/' + sections.toUrl(conductor.section())
		let regexp = new RegExp(url)
		let blankOrgUrl = Backbone.history.fragment.match(regexp) ||
			Backbone.history.fragment === 'datasets'
		if (stream.statusCode == HttpStatusCodes.NOT_FOUND && blankOrgUrl) {
			if (stream.responseJSON.empty) {
				// display the create button (only if org is empty, not missing or dereplicated)
				this.toggleTree(false, { organizationTemplateId: stream.responseJSON.organizationTemplateId })
			} else {
				this.$el.empty()
				this.clearLoadingDots()
			}
		} else {
			this.$el.empty()
			this.clearLoadingDots()
		}
		// issue 6825 after visiting an org without permission make sure trees
		// are displayed properly
		// issue 6906 set this AFTER calling toggleTree above
		this.showingTree = false
	},

	// toggles between viewing a tree or the message to create the tree
	toggleTree: function(show, options = {}) {
		let addClickListener = () => {
			if (this.$('.tree-container').length > 0) {
				// overwrite the tree's onclick behavior using a capturing event
				// instead of a bubbling event
				//
				// Note that it's safe to call this multiple times; the browser
				// will not add duplicate event listeners as long as it's the
				// exact same function, which is why we use bindAll(this, 'clickNode')
				// in initialize()
				this.$('.tree-container')[0]
					.addEventListener('click', this.clickNode, true)
			}
		}

		// if we're already showing the tree we don't need to show it again.  if
		// we aren't showing the tree, however, we do need to let the rest of
		// this method run.  this is because sometimes we want a blank nav pane
		// (when the user lacks permission), and sometimes we want a nav pane
		// with a message in it (when the user has permission but there is
		// nothing in the org).  fixes #9130
		if (this.showingTree && !!show) {
			// #25154 When toggleTree() is called, the tree-container may or may
			// not exist and have the 'click' event listener on it. We need to
			// be certain that it's added on toggleTree(true), even if we're
			// already showing it (ex: when switching organizations).
			addClickListener()
			return
		}

		this.clearLoadingDots()
		this.showingTree = !!show
		if (show) {
			// Append the parts of the nav (finder, top toolbar (optional), & tree)
			this.$el.empty().append(this.gardener.el)
			this.gardener.delegateEvents()
			// Rebind finder events since it was previousy taken from the DOM #18145
			this.gardener.finder.delegateEvents()
			addClickListener()

			// Create the navBottomBar, set it's initial edit state, and listen for
			// when it's clicked upon to update the nav collapse/edit state.
			this.renderNavBottomToolbar()

			// When a new org is selected, the tree is udpated, so we need
			// to update the collapse/expand toggles accordingly.
			if (this.$el.hasClass('nav-pane-content')) {
				this.listenTo(Backbone, 'change:org', () => {
					this.gardener.toggleCollapse(true)
					this.$el.addClass('is-tree-collapsed')
				})
			}

			// #20694 make sure the edit/done button has the correct text based
			// on the state of this._edit, which may have been set before the
			// tree and buttons were actually rendered
			this.toggleEditViewState(this._edit)
		} else {
			this._emptyTree(options)
		}
		this.$el.toggleClass('is-editing', this._edit ?? false)
		this.trigger('toggleTree', show)
	},

	/**
	 * Renders the edit button and the collapse button (which collapses the
	 * entire nav pane).  The expand all / collapse all button was already
	 * added by the gardener
	 */
	renderNavBottomToolbar() {
		const options = this.getBottomToolbarOptions()
		const { canCollapse, isEditable } = options

		this.$('.bottom-toolbar')
			.addClass('nav-or-tree-toolbar nav-bottom-toolbar')
			.toggleClass('can-collapse', canCollapse)
			.toggleClass('is-editable', this.editable)

		if (_.isEmpty(this.$('.bottom-toolbar .toggle-nav-collapsed'))) {
			// Ensure there's no edit button present before creating a new one
			isEditable && this.$('.bottom-toolbar .edit').remove()

			this.$('.bottom-toolbar').append(navBottomToolbar(options))
		}
		this.$('.bottom-toolbar .edit').toggleClass('is-not-displayed', !isEditable)
	},

	/**
	 * @see NavBottomToolbar#initialize
	 */
	getBottomToolbarOptions() {
		if (_.isNil(this.editable)) {
			this.editable = this.isEditable(this.gardener.getOrgId())
		}
		return {
			isEditable: this.editable,
			isEditing: this.$el.hasClass('is-editing'),
			canCollapse: this.section != 'organizations' ? true : false
		}
	},

	// the difference between this function and toggleEditViewState is that
	// this toggles whether or not the nav is allowed to be editable whereas
	// toggleEditViewState actually puts the nav in an editable mode
	toggleEditability(editable) {
		this.$el.toggleClass('is-editable', editable)
		if (this.editable != editable) {
			this.editable = editable
			this.renderNavBottomToolbar()
		}
	},

	// toggleEditButton can be called programmatically (forgo event trigger to prevent loop)
	// or via clicking the edit/done button
	toggleEditButton: function(isEditing) {
		return guard.conditionallyRun(() => this._toggleEditButton.apply(this, arguments))
	},

	_toggleEditButton: function(isEditing) {
		if (isEditing.type == 'click') {
			this.$('.icon-edit, .nav-edit-text').toggleClass('is-not-displayed')
			this.$('.icon-approved, .nav-done-text').toggleClass('is-not-displayed')
			this.clickEdit(isEditing)
		} else {
			this.toggleEditButtonText(isEditing)
		}
	},

	toggleEditButtonText(isEditing) {
		this.$('.icon-edit, .nav-edit-text').toggleClass('is-not-displayed', isEditing)
		this.$('.icon-approved, .nav-done-text').toggleClass('is-not-displayed', !isEditing)
	},

	// event handler for clicking on nodes in the tree.  overwrites the default
	// behavior for the tree.  Shows an unsaved changes prompt, if appropriate
	clickNode: function(e) {
		// #12321 don't prompt for unsaved changes when clicking on the togglers
		// in the tree or the tree element itself and not its children
		var target = this.$(e.target)
		if (target.parent().hasClass('toggler') || target.hasClass('toggler') || target.hasClass('tree')) {
			return
		}

		var nodeId = target.closest('li.node').data('id')
		// don't prompt for changes when clicking on the node that was already
		// selected
		let selectedId = _.get(this.gardener.tree.selected(), 'id')
		if (nodeId == selectedId &&
			// #23174 if the transient is showing, we do need to prompt for
			// unsaved changes
			_.isNil(this.gardener.tree.get(-1))) {
			return
		}

		var state = guard.showWarningIfNeeded(function() {
			let options = {}
			if (selectedId == nodeId) {
				options = { force: true }
			}
			this.gardener.tree.select(nodeId, options)
			this.applyNodeSelection()
		}.bind(this))
		if (state == guardConstants.UNSAVED_CHANGES_DETECTED) {
			// overwrite the normal behavior of the tree
			e.stopPropagation()
		}
	},

	/**
	 * Subclasses can implement if needed, this does any necessary work after
	 * a node is selected in the gardener/tree.
	 * @see organization-nav.js
	 *
	 * @return The node that was just navigated to, null if no navigation occurred
	 */
	applyNodeSelection: function() {},

	/**
	 * show a message that the tree is empty, along with a create button
	 * @param {Object} [options={}] emptyTree template options
	 * @param {Boolean} [options.noCreateOption=false] set to true to hide the create text and button
	 */
	_emptyTree: function(options={}) {
		// #57854 add a noTypeLabel to the context for the emptyTree template
		// so the empty tree message with have the section label
		// (since metadata.js is now immutable, noTypeLabel has not been added
		// to the section's metadata on the fly)
		const noTypeLabel =
			i18n.get(metadata[this.section]?.noTypeCode)?.toLowerCase()
		let context = _.extend({
				section: this.section,
				// TODO: Remove when V5 is no longer supported
				// Should just be true after V5 is gone
				useNewIconIfAvailable: isV5() ? false : true,
				noTypeLabel
			},
			options,
			metadata[this.section],
		)
		this.$el.empty().append(emptyTree(context))
		this.clearLoadingDots()
	},

	// renders the create folder dialog
	addFolder: function () {
		guard.conditionallyRun(function() {
			var url
			if (conductor.id()) {
				url = sections.toUrl(this.section) + '/' + conductor.id() + '/new-folder'
			} else {
				// this is for when we're creating the first folder in an org
				url = 'organizations/' + globals.orgId + '/' + sections.toUrl(this.section) + '/new-folder'
			}
			conductor.navigate(url, { trigger: true })
		}.bind(this))
	},

	clickEdit: function() {
		// #20412 need to return a value so the org nav can display a menu if
		// appropriate
		let doEdit = () => {
			this.gardener.tree.search(null)
			var isEditing = this.$el.hasClass('is-editing')
			return this.toggleEdit(!isEditing)
		}
		if (this.preventGuardOnClickEdit) {
			return doEdit()
		}
		return guard.conditionallyRun(doEdit)
	},

	/**
	 * Toggles the edit state to the given state.  true indicates that we should
	 * enter edit mode.  if this.changeUrl, this will change the URL to the
	 * appropriate URL and toggle the display in the display panel.
	 *
	 * Also invokes toggleEditViewState so no need to call both
	 *
	 * @param {Boolean} edit
	 */
	toggleEdit: function (edit) {
		this.toggleEditViewState(edit)

		if (this.changeUrl) {
			var url = conductor.overviewUrl()
			if (edit) {
				if (!conductor.id()) {
					// If edit is clicked after navigating to a new section
					// and before the first route loads the conductor will not yet have an id
					this.awaitingEdit = true
				} else {
					conductor.navigate(`${url}/edit`, { trigger: true })
				}
			} else if (this._mustLeaveEditMode()) {
				this._leaveEditMode(url)
			} else {
				this.awaitingEdit = false
			}
		}
		return edit
	},

	_mustLeaveEditMode: function() {
		// only if we're in add or edit mode should we navigate out of it.  this is
		// because when we visit other tabs like scorecards metrics if the URL
		// was already changed we shouldn't throw them to the overview tab
		// instead.  we could also track the edit state internally but it's
		// already in the URL so might as well use that version of the truth
		const fragment = Backbone.history.fragment
		// drilldowns are responsible for their own navigation
		// navigating during a drilldown could result in XHR(s) being aborted
		// and the wrong section being (re)loaded #36225
		return !appDisplay.isDrilldown() && fragment &&
			(conductor.isEditUrl(fragment) || fragment.indexOf('new') != -1)
	},

	_leaveEditMode: function (url) {
		if (!conductor.id()) {
			url = 'organizations/' + globals.orgId + '/' + sections.toUrl(this.section)
		}
		conductor.navigate(url, {trigger: true})
	},

	// toggles the edit state to the given state.  true indicates that we should
	// enter edit mode.  only modifies the state of the nav pane, and makes no
	// changes to the URL or display pane
	toggleEditViewState: function (edit) {
		// remember the edit setting, because when we first render this view
		// we don't even have an edit button yet so we need to wait and see if
		// the org actually has any data and then toggle the edit button when
		// the tree is ready
		this._edit = !!edit
		this.$el.toggleClass('is-editing', this._edit)
		this._toggleEditButton(this._edit)
		this.gardener.editable(this._edit)
	},

	_addDomainObject: function(model, relativeId) {
		if (!this._interested(model)) {
			return
		}

		if (this._wrongOrg(model)) {
			return
		}

		// update the URL to the new object's edit path and make sure we're in edit mode
		if (_.endsWith(Backbone.history.fragment, 'new') ||
			_.endsWith(Backbone.history.fragment, 'new-folder')) {
			conductor.navigate(conductor.editUrl(this.section, model.id))
		}
		this._edit = true
		//ensure the nav is editable
		this.toggleEditability(true)

		this.toggleTree(true)
		this.gardener.add(model, relativeId)
		this.gardener.tree.select(model.id, { silent: true })
	},

	_wrongOrg: function (model) {
		// If we're adding a model that has an organizationId, make sure that it matches the
		// org of the tree we're displaying
		var newObjectOrgId = model.get('organizationId')
		var treeOrgId = this.gardener.options.orgId
		return !_.isNil(newObjectOrgId) && !_.isNil(treeOrgId) && newObjectOrgId != treeOrgId
	},

	_deleteDomainObject: function(model) {
		return this._displaceDomainObject(model)
	},

	/**
	 * Removes a node from the current tree, either because it was deleted or
	 * moved.  Highlights a different item in the tree, based on the rules in
	 * the chooseNextSelection method.
	 *
	 * @param model
	 * @param {Number} model.id
	 * @param {String} model.domainType
	 */
	_displaceDomainObject(model = {}) {
		if (!this._interested(model)) {
			return
		}

		var tree = this.gardener.tree
		var selected = tree.selected()
		// a new selection to make, if appropriate
		var newSelection
		// if we are deleting the currently selected node
		if (selected && (selected.id == model.id)) {
			// change the selection
			newSelection = this.chooseNextSelection(model)
			newSelection && tree.select(newSelection.id)
		}

		// if we delete the last thing in the tree
		if (this.isEmpty(model.id)) {
			// replace the tree with the create button
			this.toggleTree(false)
			Backbone.trigger('empty:tree', this.section, globals.orgId)

			// If the newly emptied tree was a .nav-pane. This could be the
			// scorecards-nav, initiatives-nav, documents-nav, etc.
			if (this.section !== 'organizations' && this.section !== 'projects') {
				let url
				if (requiresOrg(this.section)) {
					url = 'organizations/' + globals.orgId + '/' + sections.toUrl(this.section)
				} else {
					url = sections.toUrl(this.section)
				}
				// fix the url
				conductor.navigate(url)
				this.displayNoObjectView()
				return
			}

			// By this point, we know that we've either just cleared out the projects tree
			// or the organizations tree. In both of those cases, we're going to want to
			// clear out the nav pane b/c there's nothing to show ther.
			appDisplay.navView().$el.empty()
			// We also need to display the notFound view in the display pane since
			// there's nothing to show there.
			appDisplay.display(new EmptyState({ body: notFound() }))
		}

		// used by organizations-nav
		return newSelection
	},

	displayNoObjectView: function() {
		this.noObjectView = new NoObjectView({ section: this.section})
		// i'm not sure how i feel about fiddling with the display pane
		// here but this is the best i can think of for now
		appDisplay.display(this.noObjectView)
	},

	/**
	 * After an item in the tree is deleted, choose the next item that should
	 * show up selected in the tree instead.
	 */
	chooseNextSelection: function(model) {
		var tree = this.gardener.tree
		return tree.nextSibling(model.id) ||
			tree.previousSibling(model.id) ||
			tree.parent(model.id)
	},

	/**
	 * Callback executed after a domain object is moved
	 *
	 * @param {Object} options
	 * @param {String} options.domainType
	 * @param {Number} options.id
	 * @param {String} options.model (e.g. 'move')
	 * @param {Number} options.oldOrgId
	 * @param {Number} options.orgId
	 * @param {Number} options.parentId
	 * @param {String} options.section
	 */
	_moveDomainObject: function(options) {
		if (options.section !== this.section) {
			return
		}

		if (this.isEmpty(options.id)) {
			Backbone.trigger('empty:tree', this.section, globals.orgId)
		}

		if (options.orgId && options.orgId != globals.orgId) {
			this._displaceDomainObject(options)
		}
	},

	// returns whether the tree will be empty if the given id is removed
	isEmpty: function(id) {
		if (!this.gardener // make things easy on complex unit tests (menu-manager-test.js)
			|| !this.gardener.tree) { // Org tree isn't loaded until a project is set
			return true
		}
		var tree = this.gardener.tree
		return _.isEmpty(tree.get())
				|| (this.gardener.forest
					? tree.get().length == 1 && tree.get()[0].id == id
					: tree.get().id == id)
	},

	toggleButtons: function(enabled) {
		this.$('.add-folder, .new, .expand-collapse, .edit').prop('disabled', !enabled)
	},

	/**
	 * TRANSIENT FUNCTIONALITY (issue 5285)
	 *
	 * To use the transient functionality, the following must all be
	 * handled.
	 *
	 * 1) All routes in the router must either add or remove the transient
	 * as appropriate.  For example:
	 *
	 *     this.addTransient(form, relativeId, attributes)
	 *     _.result(appDisplay.navView(), 'removeTransient')
	 *
	 * 2) A 'change' event must be fired by the form used to create the
	 * transient when the label or type of the transient changes
	 * 3) A 'save' event must be fired after a transient is successfully saved
	 */

	// add a placeholder (aka "transient") node to the tree where a new node
	// is about to be created
	addTransient: function(relativeId, attributes) {
		attributes = attributes.attributes || attributes
		// warning: here be dragons
		this._onceTreeLoaded(function() {
			// needing when creating the first item in the tree
			this.toggleTree(true)
			// fixes #9521 first item in tree not showing up for new connections
			this.gardener.clearLoadingDots()

			var trans = this._defaultTransient(attributes)
			var position = this.gardener.getAddPosition(attributes, relativeId)
			console.log('getAddPosition returned')
			console.dir(position)

			// make sure the new node is saved in the right spot
			attributes.parentId = position.parentId
			attributes.index = position.index

			this.gardener.clearLoadingDots()
			if (this.gardener.tree.getTransient()) {
				this.gardener.tree.editTransient(trans)
				this.gardener.tree.moveTransient(position.parentId, position.index)
			} else {
				this.gardener.tree.addTransient(trans, position.parentId, position.index)
			}

			//ensure we don't have multiple copies
			//store the dnd stop listener used because we need a reference to it
			//in order to remove it from the tree events (which use node events)
			let transient = this.gardener.tree.getTransient()
			transient.transientDndStopListener = () => {
				var position = this.gardener.getAddPosition(attributes, relativeId)
				attributes.parentId = position.parentId
				attributes.index = position.index
			}

			// #23151 need to update position after DND
			this.gardener.tree.on('dndstop', transient.transientDndStopListener)
			this.trigger('add:transient')
		}.bind(this))
	},

	_onceTreeLoaded: function(callback) {
		var allWork = function() {
			callback()
			// this is necessary in case you added the first item to a tree,
			// then edited, then pressed cancel
			this.stopListening(this.gardener, 'end error', callback)
		}.bind(this)
		this.gardener._onceTreeLoaded(allWork)
	},

	_updateTransientAttributes: function(attributes) {
		attributes = attributes.attributes || attributes
		if (_.isEmpty(attributes.label)) {
			attributes = _.extend({}, attributes, {
				label: this._defaultTransientLabel(attributes)
			})
		}

		this.gardener.tree.editTransient(attributes)
	},

	_updateTransientPosition: function(attributes) {
		var selected = this.gardener.tree.selected()
		if (selected) { // selected will be null when creating the first domain object in an org
			var position = this.gardener.getAddPosition(attributes, selected.id)
			this.gardener.tree.moveTransient(position.parentId, position.index)

			// make sure the new node is saved in the right spot
			attributes.parentId = position.parentId
			attributes.index = position.index
		}
	},

	// update the transient so that its icon and label match what the user most
	// recently typed in
	changeTransient: function(attributes) {
		this._updateTransientAttributes(attributes)
		this._updateTransientPosition(attributes)
	},

	// transform the transient into a real non-transient node
	saveTransient: function(relativeId, attributes) {
		attributes = attributes.attributes || attributes
		if (this.gardener.tree.getTransient()) {
			// this is needed to make sure init colors show up
			// correctly, and should be safe for all situations (issue #7889)
			this.gardener.tree.editTransient(attributes)
			this.gardener.tree.saveTransient(attributes.id)
		}
		this.toggleButtons(true)
	},

	removeTransient: function() {
		_.result(this.gardener, 'removeTransient')
	},

	_defaultTransient: function(attributes) {
		let transient = _.extend({}, attributes, {
			label: this._defaultTransientLabel(attributes)
		})
		if (config.replicationInputEnabled) {
			transient.className = 'sipr-item'
		}
		return transient
	},

	_defaultTransientLabel: function(attributes) {
		if (attributes.type === 'folder') {
			return i18n.get('common.newFolder')
		}
		return attributes.label || i18n.get(metadata[this.section].addLabelCode)
	},

	_editWithTooltips: function() {
		return $('body').width() > constants.EDIT_MENU_CUTOFF
	},

	resize: function() {
		if (this.isNavPane) {
			this.sizeSpy.spy()
		}
		this.gardener && this.gardener.resize()
	},

	remove: function() {
		this.$el.removeClass(this.section)
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.gardener], 'remove')
	}

})

export default Nav

Nav.__filename__ = 'components/nav.js'
